import React from 'react'

const React_Coding_Practice_9 = () => {
  return (
    <div>
      <h1>Coding Pratice 9</h1>
    </div>
  )
}

export default React_Coding_Practice_9
